var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormulateForm",
    {
      ref: "formClientTab",
      staticStyle: { height: "100%" },
      attrs: { name: "formClientTab" },
    },
    [
      _c(
        "b-container",
        { staticClass: "tab-container" },
        [
          _c(
            "b-card-actions",
            {
              attrs: {
                "no-actions": "",
                "show-loading": _vm.isCustomerLoading,
              },
            },
            [
              _c(
                "b-row",
                { attrs: { "align-h": "end" } },
                [
                  _c("b-col", { attrs: { md: "12" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "end",
                          gap: "10px",
                        },
                      },
                      [
                        !_vm.isOrder &&
                        _vm.hasRewardBalance &&
                        !_vm.hasRewardsApplied
                          ? _c("e-button", {
                              attrs: {
                                id: "pdv-tab-client-btn-apply-rewards",
                                variant: "success",
                                text:
                                  "Aplicar desconto ecash " +
                                  _vm.formatRewardBalance(_vm.rewardBalance),
                                size: "sm",
                              },
                              on: { click: _vm.applyRewards },
                            })
                          : _vm._e(),
                        !_vm.isOrder && _vm.hasRewardsApplied
                          ? _c("e-button", {
                              attrs: {
                                id: "pdv-tab-client-btn-remove-rewards",
                                variant: "danger",
                                text:
                                  "Remover desconto ecash " +
                                  _vm.$options.filters.currency(
                                    _vm.paymentForm.rewardsAmountUsed
                                  ),
                                size: "sm",
                              },
                              on: { click: _vm.removeRewards },
                            })
                          : _vm._e(),
                        !(_vm.isOrder || _vm.hasPalmBeerCustomer)
                          ? _c("e-button", {
                              attrs: {
                                id: "pdv-tab-client-btn-clean",
                                variant: "danger",
                                text: "Limpar",
                                size: "sm",
                              },
                              on: { click: _vm.onCleanForm },
                            })
                          : _vm._e(),
                        _vm.existClient && _vm.stClientForm.id != 1
                          ? _c("e-button", {
                              staticClass: "refresh-button",
                              staticStyle: { "z-index": "10" },
                              attrs: {
                                pill: "",
                                variant: "outline-secondary",
                                type: "button",
                                icon: "arrow-clockwise",
                                title: _vm.$t("Atualizar dados do cliente"),
                              },
                              on: { click: _vm.refreshCustomer },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "pdv-tab-client-person-type",
                          value: _vm.stClientForm.personType,
                          name: "personType",
                          type: "label",
                          options: _vm.personTypesOptions(),
                          label: _vm.$t("Tipo"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: _vm.showTefRequestDocument ? "6" : "7" } },
                    [
                      !_vm.existClient && !_vm.isDocumentFromTef
                        ? _c("FormulateInput", {
                            attrs: {
                              id: "pdv-tab-client-document",
                              mask: ["###.###.###-##", "XX.XXX.XXX/XXXX-##"],
                              name: "document",
                              type: "text-mask",
                              label: _vm.$t("CPF ou CNPJ"),
                              placeholder: _vm.$t("CPF ou CNPJ"),
                              validation: "optional|cpfCnpj",
                              disabled:
                                _vm.isOrder ||
                                _vm.hasPalmBeerCustomer ||
                                _vm.isCustomerLoading,
                            },
                            on: { input: _vm.onInputCustomerDocument },
                            model: {
                              value: _vm.stClientForm.document,
                              callback: function ($$v) {
                                _vm.$set(_vm.stClientForm, "document", $$v)
                              },
                              expression: "stClientForm.document",
                            },
                          })
                        : _c("FormulateInput", {
                            attrs: {
                              id: "pdv-tab-client-document",
                              name: "document",
                              type: "label",
                              label: _vm.$t("CPF ou CNPJ"),
                              filter: "cpfCnpj",
                            },
                            model: {
                              value: _vm.stClientForm.document,
                              callback: function ($$v) {
                                _vm.$set(_vm.stClientForm, "document", $$v)
                              },
                              expression: "stClientForm.document",
                            },
                          }),
                    ],
                    1
                  ),
                  _vm.showTefRequestDocument
                    ? _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { md: "2" } },
                        [
                          _c("e-button", {
                            attrs: {
                              variant: "outline-primary",
                              type: "button",
                              icon: "keyboard",
                              title: _vm.$t("Solicitar documento com PinPad"),
                              "text-shortcuts": ["F8"],
                              busy: _vm.isCustomerLoading,
                            },
                            on: { click: _vm.onRequestDocument },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              !_vm.hasCustomer && _vm.hasActivePayment
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-alert",
                            {
                              staticClass: "p-2",
                              attrs: { show: "", variant: "warning" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "Se informar um cliente, as vantagens dele não serão aplicadas, pois há pagamentos ativos na venda."
                                    )
                                  ) +
                                  " "
                              ),
                              _c("br"),
                              _c("br"),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "Para aplicar as vantagens, será necessário cancelar os pagamentos ativos e informar o cliente novamente."
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("transition", { attrs: { name: "fade" } }, [
                !_vm.isAnonymous
                  ? _c(
                      "div",
                      [
                        _vm.isNatural
                          ? [
                              _c(
                                "b-row",
                                { staticClass: "align-items-center" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "d-flex align-items-center",
                                      attrs: {
                                        md: !_vm.existClient
                                          ? "12"
                                          : _vm.isUpdating.name
                                          ? "8"
                                          : "auto",
                                      },
                                    },
                                    [
                                      _c("FormulateInput", {
                                        ref: "name",
                                        staticClass: "flex-grow-1",
                                        attrs: {
                                          id: "pdv-tab-client-name",
                                          name: "name",
                                          type:
                                            _vm.existClient &&
                                            !_vm.isUpdating.name
                                              ? "label"
                                              : "text",
                                          validation:
                                            _vm.stClientForm.id === 1
                                              ? "optional"
                                              : "optional|fullName",
                                          label: _vm.$t("Nome"),
                                          placeholder: _vm.$t("Nome"),
                                        },
                                        model: {
                                          value: _vm.stClientForm.name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.stClientForm,
                                              "name",
                                              $$v
                                            )
                                          },
                                          expression: "stClientForm.name",
                                        },
                                      }),
                                      _vm.enableEdit("name")
                                        ? _c("e-button", {
                                            staticClass: "edit-button ml-2",
                                            attrs: {
                                              pill: "",
                                              variant: "outline-secondary",
                                              type: "button",
                                              icon: "pencil",
                                              title: _vm.$t(
                                                "Alterar 'Nome' do cliente"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.ableToUpdate("name")
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm.isUpdating.name && _vm.stClientForm.id
                                    ? _c(
                                        "b-col",
                                        { staticClass: "actions pf-actions" },
                                        [
                                          _c("e-button", {
                                            staticStyle: {
                                              "margin-right": "6px",
                                            },
                                            attrs: {
                                              title: "Confirmar",
                                              size: "sm",
                                              variant: "primary",
                                              icon: "check-circle",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.updateCompanyNameOrName(
                                                  _vm.stClientForm.name,
                                                  "name"
                                                )
                                              },
                                            },
                                          }),
                                          _c("e-button", {
                                            attrs: {
                                              title: "Cancelar",
                                              size: "sm",
                                              variant: "danger",
                                              icon: "x-circle",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.cancelUpdate("name")
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        _vm.isJuridical
                          ? [
                              _c(
                                "b-row",
                                { staticClass: "align-items-center" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "d-flex align-items-center",
                                      attrs: {
                                        md: !_vm.existClient
                                          ? "12"
                                          : _vm.isUpdating.companyName
                                          ? "8"
                                          : "auto",
                                      },
                                    },
                                    [
                                      _c("FormulateInput", {
                                        ref: "companyName",
                                        staticClass: "flex-grow-1",
                                        attrs: {
                                          id: "pdv-tab-client-company-name",
                                          name: "corporateName",
                                          type:
                                            _vm.existClient &&
                                            !_vm.isUpdating.companyName
                                              ? "label"
                                              : "text",
                                          validation:
                                            _vm.stClientForm.id === 1
                                              ? "optional"
                                              : "optional|fullName",
                                          label: _vm.$t("Razão social"),
                                          placeholder: _vm.$t("Razão Social"),
                                        },
                                        model: {
                                          value: _vm.stClientForm.companyName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.stClientForm,
                                              "companyName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "stClientForm.companyName",
                                        },
                                      }),
                                      _vm.enableEdit("companyName")
                                        ? _c("e-button", {
                                            staticClass: "edit-button ml-2",
                                            attrs: {
                                              pill: "",
                                              variant: "outline-secondary",
                                              type: "button",
                                              icon: "pencil",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.ableToUpdate(
                                                  "companyName"
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm.isUpdating.companyName &&
                                  _vm.stClientForm.id
                                    ? _c(
                                        "b-col",
                                        { staticClass: "actions pf-actions" },
                                        [
                                          _c("e-button", {
                                            staticStyle: {
                                              "margin-right": "6px",
                                            },
                                            attrs: {
                                              title: "Confirmar",
                                              size: "sm",
                                              variant: "primary",
                                              icon: "check-circle",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.updateCompanyNameOrName(
                                                  _vm.stClientForm.companyName,
                                                  "companyName"
                                                )
                                              },
                                            },
                                          }),
                                          _c("e-button", {
                                            attrs: {
                                              title: "Cancelar",
                                              size: "sm",
                                              variant: "danger",
                                              icon: "x-circle",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.cancelUpdate(
                                                  "companyName"
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "pdv-tab-client-email",
                                    name: "email",
                                    type: _vm.existClient ? "label" : "text",
                                    validation: "optional|email",
                                    filter: _vm.existClient
                                      ? "emailMask"
                                      : null,
                                    label: _vm.$t("E-mail"),
                                    placeholder: _vm.$t("exemplo@email.com"),
                                  },
                                  model: {
                                    value: _vm.stClientForm.email,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.stClientForm, "email", $$v)
                                    },
                                    expression: "stClientForm.email",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                !_vm.existClient
                                  ? _c("FormulateInput", {
                                      directives: [
                                        {
                                          name: "mask",
                                          rawName: "v-mask",
                                          value: "(##) ####-####",
                                          expression: "'(##) ####-####'",
                                        },
                                      ],
                                      attrs: {
                                        id: "pdv-tab-client-phone-landline",
                                        placeholder: _vm.$t("(99) 9999-9999"),
                                        name: "phone",
                                        type: "text",
                                        label: _vm.$t("Telefone"),
                                      },
                                      model: {
                                        value: _vm.stClientForm.landLine,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.stClientForm,
                                            "landLine",
                                            $$v
                                          )
                                        },
                                        expression: "stClientForm.landLine",
                                      },
                                    })
                                  : _c("FormulateInput", {
                                      attrs: {
                                        id: "pdv-tab-client-phone-landline",
                                        value: _vm.stClientForm.landLine,
                                        name: "phone",
                                        type: "label",
                                        label: _vm.$t("Telefone"),
                                        filter: "phone",
                                      },
                                    }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              [
                                !_vm.existClient
                                  ? _c("FormulateInput", {
                                      directives: [
                                        {
                                          name: "mask",
                                          rawName: "v-mask",
                                          value: "(##) #####-####",
                                          expression: "'(##) #####-####'",
                                        },
                                      ],
                                      attrs: {
                                        id: "pdv-tab-client-phone-mobile",
                                        placeholder: _vm.$t("(99) 99999-9999"),
                                        name: "cellphone",
                                        type: _vm.existClient
                                          ? "label"
                                          : "text",
                                        filter: _vm.existClient
                                          ? "phone"
                                          : null,
                                        label: _vm.$t("Celular"),
                                      },
                                      model: {
                                        value: _vm.stClientForm.mobilePhone,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.stClientForm,
                                            "mobilePhone",
                                            $$v
                                          )
                                        },
                                        expression: "stClientForm.mobilePhone",
                                      },
                                    })
                                  : _c("FormulateInput", {
                                      attrs: {
                                        id: "pdv-tab-client-phone-mobile",
                                        value: _vm.stClientForm.mobilePhone,
                                        name: "cellphone",
                                        type: "label",
                                        filter: "phone",
                                        label: _vm.$t("Celular"),
                                      },
                                    }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _c("transition", { attrs: { name: "fade" } }, [
            !_vm.isAnonymous
              ? _c(
                  "div",
                  [
                    _c(
                      "b-card-actions",
                      {
                        attrs: {
                          title: _vm.$t("Outros dados"),
                          "no-actions": "",
                          "show-loading": _vm.fetching,
                        },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "pdv-tab-client-observation",
                                    name: "observation",
                                    type: _vm.existClient
                                      ? "label"
                                      : "textarea",
                                    label: _vm.$t("Observação"),
                                    placeholder: _vm.$t("Observação"),
                                  },
                                  model: {
                                    value: _vm.stClientForm.observation,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.stClientForm,
                                        "observation",
                                        $$v
                                      )
                                    },
                                    expression: "stClientForm.observation",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.isNatural
                          ? [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("FormulateInput", {
                                        attrs: {
                                          id: "pdv-tab-client-birthdate",
                                          name: "birthdate",
                                          type: _vm.existClient
                                            ? "label"
                                            : "datepicker",
                                          filter: _vm.existClient
                                            ? "dateMask"
                                            : null,
                                          label: _vm.$t("Data de nascimento"),
                                          disabled: _vm.existClient,
                                          max: _vm.today,
                                        },
                                        model: {
                                          value: _vm.stClientForm.birthdate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.stClientForm,
                                              "birthdate",
                                              $$v
                                            )
                                          },
                                          expression: "stClientForm.birthdate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        _vm.isJuridical
                          ? [
                              _c(
                                "b-row",
                                { staticClass: "align-items-center" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "d-flex align-items-center",
                                      attrs: {
                                        md: !_vm.existClient
                                          ? "12"
                                          : _vm.isUpdating.name
                                          ? "8"
                                          : "auto",
                                      },
                                    },
                                    [
                                      _c("FormulateInput", {
                                        ref: "name",
                                        staticClass: "flex-grow-1",
                                        attrs: {
                                          id: "pdv-tab-client-name",
                                          name: "name",
                                          type:
                                            _vm.existClient &&
                                            !_vm.isUpdating.name
                                              ? "label"
                                              : "text",
                                          label: _vm.$t("Nome Fantasia"),
                                          placeholder: _vm.$t("Nome Fantasia"),
                                        },
                                        model: {
                                          value: _vm.stClientForm.name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.stClientForm,
                                              "name",
                                              $$v
                                            )
                                          },
                                          expression: "stClientForm.name",
                                        },
                                      }),
                                      _vm.enableEdit("name")
                                        ? _c("e-button", {
                                            staticClass: "edit-button ml-2",
                                            attrs: {
                                              pill: "",
                                              variant: "outline-secondary",
                                              type: "button",
                                              icon: "pencil",
                                              title: _vm.$t(
                                                "Alterar 'Nome Fantasia' do cliente"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.ableToUpdate("name")
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm.isUpdating.name && _vm.stClientForm.id
                                    ? _c(
                                        "b-col",
                                        { staticClass: "actions pf-actions" },
                                        [
                                          _c("e-button", {
                                            staticStyle: {
                                              "margin-right": "6px",
                                            },
                                            attrs: {
                                              title: "Confirmar",
                                              size: "sm",
                                              variant: "primary",
                                              icon: "check-circle",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.updateCompanyNameOrName(
                                                  _vm.stClientForm.name,
                                                  "name"
                                                )
                                              },
                                            },
                                          }),
                                          _c("e-button", {
                                            attrs: {
                                              title: "Cancelar",
                                              size: "sm",
                                              variant: "danger",
                                              icon: "x-circle",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.cancelUpdate("name")
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("FormulateInput", {
                                        attrs: {
                                          id: "pdv-tab-client-state-registration-type",
                                          name: "stateRegistrationType",
                                          type: _vm.existClient
                                            ? "label"
                                            : "vue-select",
                                          label: _vm.$t("Indicador da IE"),
                                          placeholder: _vm.$t("Selecione"),
                                          options: _vm.indicatorIETypes(),
                                        },
                                        model: {
                                          value:
                                            _vm.stClientForm
                                              .stateRegistrationType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.stClientForm,
                                              "stateRegistrationType",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "stClientForm.stateRegistrationType",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    [
                                      _c("FormulateInput", {
                                        attrs: {
                                          id: "pdv-tab-client-state-registration",
                                          name: "stateRegistration",
                                          type: _vm.existClient
                                            ? "label"
                                            : "text",
                                          filter: _vm.existClient
                                            ? "rgIeMask"
                                            : null,
                                          label: _vm.$t("Inscrição estadual"),
                                          maxlength: "20",
                                          disabled: [
                                            _vm.indicatorIETypesEnum
                                              .EXEMPT_REGISTRATION,
                                            _vm.indicatorIETypesEnum
                                              .NO_TAXPAYER,
                                          ].includes(
                                            _vm.stClientForm
                                              .stateRegistrationType
                                          ),
                                        },
                                        model: {
                                          value:
                                            _vm.stClientForm.stateRegistration,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.stClientForm,
                                              "stateRegistration",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "stClientForm.stateRegistration",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm.existClient &&
                    _vm.stClientForm.id &&
                    _vm.stClientForm.id !== 1
                      ? [
                          _c(
                            "b-card-actions",
                            {
                              attrs: {
                                title: _vm.$t("Programa ecash"),
                                "show-loading": _vm.loadingRewardBalance,
                                "no-actions": "",
                              },
                            },
                            [
                              _vm.rewardBalance !== null
                                ? _c(
                                    "b-row",
                                    [
                                      _c("b-col", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center",
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa fa-gift text-success mr-2",
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-weight-medium",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("Saldo ecash")
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "b-badge",
                                              {
                                                staticClass: "ml-2 px-2 py-1",
                                                attrs: {
                                                  variant: _vm.hasRewardBalance
                                                    ? "success"
                                                    : "secondary",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.formatRewardBalance(
                                                        _vm.rewardBalance
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm.hasRewardBalance
                                          ? _c(
                                              "small",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "O cliente pode usar este saldo para desconto na compra"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    !_vm.isKioskStore &&
                    _vm.existClient &&
                    _vm.stClientForm.id &&
                    _vm.stClientForm.id !== 1 &&
                    _vm.isNatural
                      ? [
                          _c(
                            "b-card-actions",
                            {
                              attrs: {
                                title: _vm.$t("Clube echope"),
                                "show-loading": _vm.loadingEchopeClubBalance,
                                "no-actions": "",
                              },
                            },
                            [
                              _c(
                                "b-row",
                                { staticClass: "align-items-center" },
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("e-button", {
                                        attrs: {
                                          id: "pdv-tab-client-btn-echope-club-balance",
                                          variant: "outline-primary",
                                          text: _vm.$t("Consultar saldo"),
                                          icon: "currency-dollar",
                                          size: "sm",
                                          busy: _vm.loadingEchopeClubBalance,
                                          disabled: !_vm.stClientForm.document,
                                        },
                                        on: {
                                          click: _vm.onConsultEchopeClubBalance,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.echopeClubBalance !== null
                                ? _c(
                                    "b-row",
                                    { staticClass: "mt-1" },
                                    [
                                      _c("b-col", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center",
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa fa-star text-warning mr-2",
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-weight-medium",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("Saldo Clube echope")
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "b-badge",
                                              {
                                                staticClass: "ml-2 px-2 py-1",
                                                attrs: {
                                                  variant:
                                                    _vm.hasEchopeClubBalance
                                                      ? "success"
                                                      : "secondary",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("currency")(
                                                        _vm.echopeClubBalance
                                                          .balance
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm.hasEchopeClubBalance
                                          ? _c(
                                              "small",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "O cliente pode usar este saldo como forma de pagamento"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _vm.existClient
                              ? [
                                  _c(
                                    "b-card-actions",
                                    {
                                      attrs: {
                                        title: _vm.$t("Endereço"),
                                        "show-loading": _vm.fetching,
                                        "no-actions": "",
                                      },
                                    },
                                    [
                                      _c("e-address", {
                                        attrs: {
                                          required: false,
                                          "show-loading": true,
                                          "read-only": true,
                                        },
                                        model: {
                                          value: _vm.stClientForm.address,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.stClientForm,
                                              "address",
                                              $$v
                                            )
                                          },
                                          expression: "stClientForm.address",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : [
                                  _c("e-address", {
                                    attrs: {
                                      required: false,
                                      "show-loading": _vm.fetching,
                                    },
                                    model: {
                                      value: _vm.stClientForm.address,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.stClientForm,
                                          "address",
                                          $$v
                                        )
                                      },
                                      expression: "stClientForm.address",
                                    },
                                  }),
                                ],
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
      _c("reward-code-verification-modal", {
        ref: "codeVerificationModal",
        attrs: { "show-virtual-keyboard": false, "show-overlay-loading": true },
        on: {
          verified: _vm.onCodeVerified,
          cancelled: _vm.onCodeVerificationCancelled,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }